export default "__VITE_ASSET__CgnIE5xy__"